export default __webpack_public_path__ + "static/media/logout.f92f424c.svg";